import { MessageDescriptor, useIntl } from 'react-intl';

export function useTranslation() {
  const intl = useIntl();

  /** @todo Enforce a format for id. */
  const t = (
    id: string,
    defaultMessage: string,
    values?: Record<string, any>,
    opts?: Partial<MessageDescriptor>
  ) => {
    return intl.formatMessage({ id, defaultMessage, ...opts }, values);
  };

  return { t };
}
